module.exports = __webpack_public_path__ + "img/pic_cz_z.11e21a71.png";